import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { renewalsBulkAssignSchema } from "../renewalsSchemas";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import {
  bulkAssignRenewals,
  clearOperationResult,
  clearBulkAssignData,
} from "../../../store/renewal/renewalActions";
import { Button, Col, Divider, Form, Row } from "antd";
import { SaveOutlined } from "@ant-design/icons";
import openNotificationOperationResult from "../../shared/openNotificationOperationResult";
import SearchSelectEx from "../../shared/form/SearchSelectEx";

const initialValues = {
  AssigneeUserKey: null
};

const BulkUpdateAssigneeForm = ({
  renewalKeys,
  onCancel,
  targets,
  targetsLoading,
}) => {
  const {
    handleSubmit,
    control,
    formState: { isValid },
  } = useForm({
    mode: "onChange",
    defaultValues: initialValues,
    resolver: yupResolver(renewalsBulkAssignSchema),
  });

  const dispatch = useDispatch();

  const loading = useSelector(
    (state) => state.renewal.bulkAssign.loading
  );
  const operationResult = useSelector(
    (state) => state.renewal.bulkAssign.operationResult
  );

  useEffect(() => {
    return () => {
      dispatch(clearBulkAssignData());
    };
  }, [dispatch]);

  useEffect(() => {
    if (!operationResult) return;

    openNotificationOperationResult(operationResult, () =>
      dispatch(clearOperationResult())
    );

    if (operationResult.Outcome === "Success") {
      onCancel(true);
    }

  }, [operationResult, dispatch]);

  const onSubmitHandler = (values) => {
    dispatch(bulkAssignRenewals(renewalKeys, values.AssigneeUserKey));
  };

  return (
    <Form
      size="small"
      autoComplete="off"
      onFinish={handleSubmit(onSubmitHandler)}
      colon={false}
      style={{ marginTop: 16 }}
    >
      <Row justify="center">
        <Col span={24}>
          <SearchSelectEx
            name="AssigneeUserKey"
            control={control}
            formLabel="Processing Agent"
            required
            placeholder="Select agent"
            loading={targetsLoading}
            allowClear
            style={{ width: "100%" }}
            options={targets.map((a) => ({
              value: a.UserKey,
              label: a.UserName,
            }))}
          />
        </Col>
      </Row>

      <Divider style={{ marginBottom: 16, marginTop: 16 }} />

      <Row justify="center">
        <Col style={{ paddingRight: "8px" }}>
          <Button
            size="small"
            type="primary"
            htmlType="submit"
            loading={loading}
            disabled={!isValid || loading}
          >
            <SaveOutlined /> Save
          </Button>
        </Col>

        <Col>
          <Button
            size="small"
            type="dashed"
            onClick={() => onCancel(false)}
          >
            Close
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default BulkUpdateAssigneeForm;